import { useField } from 'formik'
import { BrandPlanTactic } from 'types'
import { CheckboxGroup } from 'components/CheckboxGroup/CheckboxGroup'
import Styles from './CrosspostTactics.module.scss'
import cx from 'classnames'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { TacticCheckbox } from './TacticCheckbox'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

interface CrosspostTacticsProps {
  className?: string
  applyRedesign?: boolean
}

export const CrosspostTactics = ({ className, applyRedesign = false }: CrosspostTacticsProps) => {
  const isOnboardingRedesign = applyRedesign
  const [{ value }, , { setValue }] = useField<BrandPlanTactic[]>('tactics')
  const googleMyBusinessEnabled = useFlipperFlag('google_business_profile_integration')

  return (
    <CheckboxGroup
      value={value}
      onChange={(value) => setValue(value as BrandPlanTactic[])}
      className={cx(Styles.group, className, { [Styles.applyRedesign]: isOnboardingRedesign })}
      aria-label="Crosspost platforms"
    >
      <TacticCheckbox
        provider={ExternalIntegrationEnum.Instagram}
        label="Instagram"
        applyRedesign={applyRedesign}
        value={BrandPlanTactic.Instagram}
        isDisabled={!value.includes(BrandPlanTactic.Instagram)}
        onCancel={() => setValue(value)}
      />
      <TacticCheckbox
        provider={ExternalIntegrationEnum.Facebook}
        label="Facebook"
        applyRedesign={applyRedesign}
        value={BrandPlanTactic.Facebook}
        isDisabled={!value.includes(BrandPlanTactic.Facebook)}
        onCancel={() => setValue(value)}
      />
      <TacticCheckbox
        provider={ExternalIntegrationEnum.LinkedIn}
        label="LinkedIn"
        applyRedesign={applyRedesign}
        value={BrandPlanTactic.LinkedIn}
        isDisabled={!value.includes(BrandPlanTactic.LinkedIn)}
        onCancel={() => setValue(value)}
      />
      <TacticCheckbox
        provider={ExternalIntegrationEnum.X}
        label="X"
        applyRedesign={applyRedesign}
        value={BrandPlanTactic.Twitter}
        isDisabled={!value.includes(BrandPlanTactic.Twitter)}
        onCancel={() => setValue(value)}
      />
      {googleMyBusinessEnabled && (
        <TacticCheckbox
          provider={ExternalIntegrationEnum.GoogleBusinessProfile}
          label="Business Profile Updates"
          applyRedesign={applyRedesign}
          value={BrandPlanTactic.GoogleBusinessProfile}
          isDisabled={!value.includes(BrandPlanTactic.GoogleBusinessProfile)}
          onCancel={() => setValue(value)}
          tooltip="GBP, formerly Google My Business"
        />
      )}
    </CheckboxGroup>
  )
}
